import { CoachElementTokenProvider } from '@efdigital/ll-addon-coaching/components/third-party/cronofy/coach-element-token-provider';
import { CronofyAvailabilityViewer } from '@efdigital/ll-addon-coaching/components/third-party/cronofy/elements/availability-viewer';
import CoacheeSlotPreview from '@efdigital/ll-xceed-v2/components/coaching/coach/coachee-slot-preview';
import {
  AVAILABILITY_PREVIEW_WEEK_START,
  buildAvailabilityPreviewQuery,
} from '@efdigital/ll-xceed-v2/utils/coaching/availability-preview-query';
import { PAGE_WRAPPER_CONTENT } from '@efdigital/ll-xceed-v2/utils/layout';
import type { TOC } from '@ember/component/template-only';
import { hash } from '@ember/helper';
import { LinkTo } from '@ember/routing';
import type { AvailabilityViewerCallback } from 'cronofy-elements';
import { pageTitle } from 'ember-page-title';

interface AvailabilityPreviewSignature {
  Args: {
    model: unknown;
    controller: unknown;
  };
}

const availabilityViewerAction: AvailabilityViewerCallback = () => {};

<template>
  {{pageTitle "Availability Preview"}}

  <div class={{PAGE_WRAPPER_CONTENT}}>
    <CoachElementTokenProvider as |cronofyContext|>
      {{#if cronofyContext.accountStatus.accountSub}}
        <h3 class="gud-eyebrow pt-3">Availability preview</h3>
        <p class="lead">
          This is how your availability appears to coachees when they book a
          session. It combines your saved working hours with your synced
          calendar, so it only reflects working hours you have already saved.
        </p>

        <CoacheeSlotPreview @cronofyContext={{cronofyContext}} class="mb-5" />

        <section
          aria-labelledby="availability-week-heading"
          data-test-availability-week
        >
          <h4 id="availability-week-heading" class="h5 mb-2">
            Your week at a glance
          </h4>
          <p class="mb-3">
            When you are free over the next two weeks, in 30-minute blocks.
            Notice periods aren't applied here, so it can show times the picker
            above doesn't.
          </p>
          <CronofyAvailabilityViewer
            @cronofyContext={{cronofyContext}}
            @onAction={{availabilityViewerAction}}
            @elementConfig={{hash
              week_start_day=AVAILABILITY_PREVIEW_WEEK_START
            }}
            @availabilityQuery={{buildAvailabilityPreviewQuery
              (hash coachSub=cronofyContext.accountStatus.accountSub)
            }}
          />
        </section>
      {{else}}
        <h3 class="gud-eyebrow pt-3">Availability preview</h3>
        <p class="lead">
          You need to connect your calendars and set your working hours to see
          how your availability appears to coachees.
        </p>
        <p class="mb-0">
          <LinkTo
            @route="coaching.coach.settings.availability"
            class="btn btn-primary"
          >
            Set up calendar sync
          </LinkTo>
        </p>
      {{/if}}
    </CoachElementTokenProvider>
  </div>
</template> satisfies TOC<AvailabilityPreviewSignature>;
